import React from 'react';
import PropTypes from 'prop-types';

import RsSlidableNavigationPrev from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationPrev';
import RsSlidableNavigationNext from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationNext';

export function PrevNavigation({ prevDisabled, goPrev }) {
  return (
    <div className="rs-slidable-navigation rs-slidable-navigation--both-sides rs-slidable-navigation--prev">
      <RsSlidableNavigationPrev disabled={prevDisabled} onClick={goPrev} />
    </div>
  );
}

PrevNavigation.propTypes = {
  prevDisabled: PropTypes.bool,
  goPrev: PropTypes.func,
};

export function NextNavigation({ nextDisabled, goNext }) {
  return (
    <div className="rs-slidable-navigation rs-slidable-navigation--both-sides rs-slidable-navigation--next">
      <RsSlidableNavigationNext disabled={nextDisabled} onClick={goNext} />
    </div>
  );
}

NextNavigation.propTypes = {
  nextDisabled: PropTypes.bool,
  goNext: PropTypes.func,
};
